import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { colors } from '../constants/colors';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

export const IconWarning = ({
  width = 24,
  height = 24,
  color = colors.gray2,
  ...rest
}: Props) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      //   xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <Path
        d="M2.725 21a.973.973 0 01-.85-.5 1.098 1.098 0 01-.138-.488.898.898 0 01.138-.512l9.25-16c.1-.167.229-.292.387-.375.159-.083.321-.125.488-.125.166 0 .329.042.487.125a.983.983 0 01.388.375l9.25 16c.1.167.146.337.137.512a1.098 1.098 0 01-.137.488.973.973 0 01-.85.5H2.725zm1.725-2h15.1L12 6 4.45 19zM12 18c.283 0 .52-.096.712-.288A.968.968 0 0013 17a.968.968 0 00-.288-.712A.968.968 0 0012 16a.968.968 0 00-.713.288A.968.968 0 0011 17c0 .283.096.52.287.712.192.192.43.288.713.288zm0-3c.283 0 .52-.096.712-.287A.968.968 0 0013 14v-3a.968.968 0 00-.288-.713A.968.968 0 0012 10a.968.968 0 00-.713.287A.968.968 0 0011 11v3c0 .283.096.52.287.713.192.191.43.287.713.287z"
        fill={color}
      />
    </Svg>
  );
};
